import { Component } from '@angular/core';

@Component({
  selector: 'app-container-details-skeleton',
  standalone: true,
  templateUrl: './container-details-skeleton.component.html',
  styleUrl: './container-details-skeleton.component.scss'
})
export class ContainerDetailsSkeletonComponent {
  readonly skeletonCols = new Array(2);
  readonly skeletonRows = new Array(8);
}
